/**
 * Eligible zipcodes for AZ Panda Flu Vaccine Study
 * Generated from CSV - DO NOT EDIT MANUALLY
 * Total zipcodes: 106 (30 mile radius)
 */
export const azPandaEligibleZipCodes: readonly string[] = [
  "51501", "51502", "51503", "51510", "51526", "51534", "51542", "51546", "51548", "51550",
  "51553", "51554", "51555", "51556", "51559", "51561", "51571", "51575", "51576", "68002",
  "68003", "68005", "68007", "68008", "68010", "68016", "68018", "68022", "68023", "68025",
  "68026", "68028", "68029", "68033", "68034", "68037", "68041", "68042", "68044", "68046",
  "68048", "68056", "68058", "68059", "68064", "68066", "68068", "68069", "68073", "68101",
  "68102", "68103", "68104", "68105", "68106", "68107", "68108", "68109", "68110", "68111",
  "68112", "68113", "68114", "68116", "68117", "68118", "68119", "68122", "68123", "68124",
  "68127", "68128", "68130", "68131", "68132", "68133", "68134", "68135", "68136", "68137",
  "68138", "68139", "68142", "68144", "68145", "68147", "68152", "68154", "68157", "68164",
  "68172", "68175", "68176", "68178", "68179", "68180", "68182", "68183", "68197", "68198",
  "68366", "68403", "68407", "68409", "68463",
] as const;
